export default __webpack_public_path__ + "media/images/react_icons/property/gallery-2639b40c8073e8b847b20584c464ba04.svg";